import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';
import Looks3Icon from '@mui/icons-material/Looks3';
import LooksOneIcon from '@mui/icons-material/LooksOne';
import LooksTwoIcon from '@mui/icons-material/LooksTwo';
import {
  Box,
  Button,
  Container,
  Grid,
  Link,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Paper,
  Stack,
  Tooltip,
  Typography,
} from '@mui/material';
import { useEffect, useState } from 'react';
import CountUp from 'react-countup';
import { useInView } from 'react-intersection-observer';

import ExtensionSubMenu from '@/components/nav/ExtensionSubMenu';
import ComingSoonPopup from '@/components/ui/ComingSoonPopup';
import Hidden from '@/components/ui/TzoHidden';
import VideoPopup from '@/components/VideoPopup';
import AppLayout from '@/layouts/AppLayout';
import { Meta } from '@/layouts/Meta';

const MobileAppForm4868 = () => {
  const [open, setOpen] = useState(false);

  // const [isvideoPopupAuto, setvideoPopupAuto] = useState(false);
  const [isvideoPopupSteps, setvideoPopupSteps] = useState(false);

  // const openPopupSteps = () => {
  //   setvideoPopupSteps(true);
  // };

  const [visible, setVisible] = useState(false);

  const { ref, inView } = useInView({
    threshold: 0.2,
    triggerOnce: false, // change to true if you only want to animate once
  });

  useEffect(() => {
    setVisible(inView);
  }, [inView]);
  // const layoutWrapperContents: LayoutWrapperContents = {
  //   Heading: 'Need to claim a refund using Form 8849?',
  //   SubHeading:
  //     'File it hassle-free and get your money back. E-file now for a quick refund.',
  //   CtaText: 'E-file Form 8849 Now',
  //   CtaSubHeading: `Get your refund now`,
  //   CtaURL: `${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=mobile868sticky`,
  //   isActive: true,
  // };
  return (
    <AppLayout
      // LayoutWrapperContents={layoutWrapperContents}
      meta={
        <Meta
          title="E-File IRS Form 4868 on Mobile App | Individual Income Tax"
          description="File Extension Form 4868 directly from the TaxZerone mobile app. Get a 6-month personal income tax extension with secure, IRS-authorized e-filing in minutes."
          keywords=""
          canonical="tax-extension/form-4868-mobile-app/"
          jsonLdPricing="11.99"
          jsonLdAggregateRatingValue="4.95"
          jsonLdAggregateRatingCount="10859"
          ogShareImg="assets/images/extension-share-img.png"
        />
      }
    >
      <ExtensionSubMenu />

      <VideoPopup
        isvideoPopup={isvideoPopupSteps}
        setvideoPopup={setvideoPopupSteps}
        src="https://www.youtube.com/embed/QnUmGYD2yLw?autoplay=1&rel=0"
      />
      <ComingSoonPopup open={open} setOpen={setOpen} />
      <Container maxWidth="xl" component="section">
        <Stack
          direction={{ xs: 'column', md: 'row' }}
          spacing={3}
          sx={{ px: { xs: 2, md: 0 } }}
        >
          <Box
            sx={{
              textAlign: { xs: 'center', md: 'left' },
              alignItems: 'center',
              display: 'flex',
              width: '100%',
              maxWidth: { xs: 'inherit', lg: 770 },
              minWidth: { xs: 'inherit', md: 530 },
              pl: { xs: 0, md: 6, lg: 8, xl: 12 },
              justifyContent: 'center',
            }}
          >
            <Box
              component="div"
              sx={{ mt: { xs: 2, sm: 4, md: 5 }, mb: { xs: 2, sm: 4, md: 5 } }}
            >
              <Typography
                variant="h1"
                sx={{
                  fontSize: { lg: 40, md: 30, sm: 24, xs: 24 },
                  fontWeight: 600,
                  color: '#374151',
                  mb: 3,
                }}
              >
                File IRS{' '}
                <span className="highlight-container">
                  <span className="highlight">Form 4868</span>
                </span>{' '}
                in Minutes with TaxZerone Mobile App
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: { lg: 20, md: 18, sm: 16, xs: 16 },
                  fontWeight: 400,
                  mb: 6,
                }}
              >
                <span style={{ fontWeight: 600 }}>
                  Get an Automatic 6-Month Extension for Your Personal Income
                  Tax Return
                </span>
                <br />
                Need more time? File Form 4868 directly from your phone using
                our mobile app -simple, secure, and accurate to request your
                extension.
              </Typography>
              <Box
                sx={{
                  my: 1,
                  mb: 0,
                  '& img': {
                    width: { xs: 120, sm: 180 },
                    height: { xs: 37, sm: 55 },
                  },
                }}
              >
                <Link
                  href="https://play.google.com/store/apps/details?id=com.taxzerone.extension4868"
                  target="_blank"
                  sx={{
                    mr: { xs: 1, sm: 1 },
                    my: { xs: 0, sm: 0 },
                    display: 'inline-block',
                  }}
                >
                  <Tooltip title="Available on the Google Play" arrow>
                    <picture>
                      <source srcSet="/assets/images/play-store-img.webp" />
                      <source srcSet="/assets/images/play-store-img.png" />
                      <img
                        src="/assets/images/play-store-img.png"
                        alt="Available on the Google Play"
                        width={180}
                        height={55}
                      />
                    </picture>
                  </Tooltip>
                </Link>
                <Link
                  href="https://apps.apple.com/us/app/e-file-irs-extension-form-4868/id6478850013"
                  target="_blank"
                  sx={{
                    ml: { xs: 1, sm: 1 },
                    my: { xs: 0, sm: 0 },
                    display: 'inline-block',
                  }}
                >
                  <Tooltip title="Download on the App Store" arrow>
                    <picture>
                      <source srcSet="/assets/images/app-store-img.webp" />
                      <source srcSet="/assets/images/app-store-img.png" />
                      <img
                        src="/assets/images/app-store-img.png"
                        alt="Download on the App Store"
                        width={180}
                        height={55}
                      />
                    </picture>
                  </Tooltip>
                </Link>
              </Box>
            </Box>
          </Box>
          <Hidden smDown>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'flex-end',
                alignItems: 'flex-end',
                width: '100%',
              }}
            >
              <picture style={{ marginBottom: -7 }}>
                <source
                  srcSet="/assets/images/app4868-landing-img.webp"
                  className="img-responsive-banner"
                />
                <source
                  srcSet="/assets/images/app4868-landing-img.png"
                  className="img-responsive-banner"
                />
                <img
                  src="/assets/images/app4868-landing-img.png"
                  alt="File IRS Form 4868 in Minutes with TaxZerone Mobile App "
                  className="img-responsive-banner"
                  width={880}
                  height={725}
                />
              </picture>
            </Box>
          </Hidden>
        </Stack>
      </Container>

      <Box
        component="section"
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
          py: { lg: 6, md: 6, sm: 5, xs: 4 },
        }}
      >
        <Container maxWidth="lg">
          <Grid
            container
            spacing={2}
            m={0}
            mt={0}
            className="MuiGrid-root-width"
            sx={{ flexDirection: { xs: 'column', md: 'row' } }}
          >
            <Grid size={12} textAlign="center">
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mb: 3,
                }}
              >
                Individuals Who Trust TaxZerone for IRS Extension 4868
              </Typography>
            </Grid>
          </Grid>
          <Grid container spacing={2} p={2}>
            <Grid size={{ xs: 12, sm: 6, md: 3 }}>
              <Paper
                variant="outlined"
                sx={{
                  textAlign: 'center',
                  p: 2,
                  backgroundColor: '#fff',
                  borderRadius: 3,
                  width: '100%',
                  height: 'auto',
                  minHeight: '100%',
                  border: 'none',
                  boxShadow: 'rgba(100, 100, 111, 0.2) 0px 7px 29px 0px',
                }}
              >
                <Box component="div" ref={ref}>
                  {visible ? (
                    <CountUp
                      end={60000}
                      duration={2}
                      suffix="+"
                      style={{
                        fontWeight: 600,
                        fontSize: 44,
                      }}
                    />
                  ) : (
                    'Extensions Filed Successfully '
                  )}
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { md: 20, sm: 20, xs: 18 },
                    fontWeight: 600,
                    mt: 1,
                    color: '#6d6d6d',
                  }}
                >
                  Extensions Filed Successfully
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 3 }}>
              <Paper
                variant="outlined"
                sx={{
                  textAlign: 'center',
                  p: 2,
                  backgroundColor: '#fff',
                  borderRadius: 3,
                  width: '100%',
                  height: 'auto',
                  minHeight: '100%',
                  border: 'none',
                  boxShadow: 'rgba(100, 100, 111, 0.2) 0px 7px 29px 0px',
                }}
              >
                <Box
                  sx={{
                    textAlign: 'center',
                    display: 'grid',
                    gridTemplateColumns: 'auto auto ',
                    columnGap: 1,
                    placeContent: 'start',
                    margin: 'auto',
                    justifyContent: 'center',
                    position: 'relative',
                  }}
                >
                  <Box component="div" ref={ref}>
                    {visible ? (
                      <CountUp
                        end={4.99}
                        duration={1}
                        decimal="."
                        decimals={1}
                        // suffix="⭐"
                        style={{
                          fontWeight: 600,
                          fontSize: 44,
                        }}
                      />
                    ) : (
                      'Customer Rating '
                    )}
                  </Box>
                  <img
                    src="/assets/images/star-icon.svg"
                    width={30}
                    height={28}
                    alt="star-1"
                    style={{ top: 18, position: 'relative' }}
                  />
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { md: 20, sm: 20, xs: 18 },
                    fontWeight: 600,
                    mt: 1,
                    color: '#6d6d6d',
                  }}
                >
                  Customer Rating
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 3 }}>
              <Paper
                variant="outlined"
                sx={{
                  textAlign: 'center',
                  p: 2,
                  backgroundColor: '#fff',
                  borderRadius: 3,
                  width: '100%',
                  height: 'auto',
                  minHeight: '100%',
                  border: 'none',
                  boxShadow: 'rgba(100, 100, 111, 0.2) 0px 7px 29px 0px',
                }}
              >
                <Box component="div" ref={ref}>
                  {visible ? (
                    <CountUp
                      end={100}
                      duration={2}
                      suffix="%"
                      style={{
                        fontWeight: 600,
                        fontSize: 44,
                      }}
                    />
                  ) : (
                    'IRS Acceptance Rate'
                  )}
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { md: 20, sm: 20, xs: 18 },
                    fontWeight: 600,
                    mt: 1,
                    color: '#6d6d6d',
                  }}
                >
                  IRS Acceptance
                  <br />
                  Rate
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 3 }}>
              <Paper
                variant="outlined"
                sx={{
                  textAlign: 'center',
                  p: 2,
                  backgroundColor: '#fff',
                  borderRadius: 3,
                  width: '100%',
                  height: 'auto',
                  minHeight: '100%',
                  border: 'none',
                  boxShadow: 'rgba(100, 100, 111, 0.2) 0px 7px 29px 0px',
                }}
              >
                <Box component="div" ref={ref}>
                  {visible ? (
                    <CountUp
                      end={3}
                      duration={1}
                      suffix="Min"
                      style={{
                        fontWeight: 600,
                        fontSize: 44,
                      }}
                    />
                  ) : (
                    'Average Filing time '
                  )}
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { md: 20, sm: 20, xs: 18 },
                    fontWeight: 600,
                    mt: 1,
                    color: '#6d6d6d',
                  }}
                >
                  Average Filing
                  <br />
                  time
                </Typography>
              </Paper>
            </Grid>
          </Grid>
        </Container>
      </Box>
      <Box
        component="section"
        sx={{
          backgroundColor: '#fff',
          py: { lg: 8, md: 8, sm: 4, xs: 4 },
          mx: '0 !important',
          mb: 0,
        }}
      >
        <Container sx={{ maxWidth: '1200px !important' }}>
          <Grid
            container
            spacing={2}
            m={2}
            mt={0}
            className="MuiGrid-root-width"
          >
            <Grid size={12} textAlign="center">
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mb: 3,
                }}
              >
                How to E-File IRS Form 4868 using the TaxZerone Mobile App?
              </Typography>

              <Typography
                variant="h3"
                sx={{
                  fontSize: { lg: 24, md: 22, sm: 20, xs: 18 },
                  fontWeight: 400,
                  mb: 3,
                  lineHeight: 1.2,
                }}
              >
                Request your personal tax extension in minutes using our
                friendly mobile app:
              </Typography>
              <Stack
                direction={{ xs: 'column', md: 'row' }}
                spacing={1}
                alignItems="center"
              >
                <Box
                  sx={{
                    '& img': {
                      width: { xs: '100%', sm: 500 },
                      height: { xs: '100%', sm: 500 },
                    },
                  }}
                >
                  <picture>
                    <source
                      srcSet="/assets/images/4868app-steps-img.webp"
                      className="img-responsive-banner"
                      width={500}
                      height={500}
                    />
                    <source
                      srcSet="/assets/images/4868app-steps-img.png"
                      className="img-responsive-banner"
                      width={500}
                      height={500}
                    />
                    <img
                      src="/assets/images/4868app-steps-img.png"
                      alt="How to E-File IRS Form 4868 using the TaxZerone Mobile App?"
                      width={500}
                      height={500}
                    />
                  </picture>
                </Box>
                <Box sx={{ textAlign: 'left', width: '100%', maxWidth: 450 }}>
                  <Box
                    component="ul"
                    sx={{
                      textAlign: 'left',
                      listStyleType: 'none',
                      p: 0,
                      '& li': {
                        mb: 3.5,
                        display: 'flex',
                        alignItems: 'flex-start',
                        justifyContent: 'flex-start',
                      },
                    }}
                  >
                    <li>
                      <LooksOneIcon
                        sx={{ color: '#1da94a', mr: 1, mb: -0.7 }}
                      />
                      <Box>
                        <span style={{ fontWeight: 600 }}>
                          Download & Sign In
                        </span>
                        <br />
                        Get TaxZerone's Form 4868 app on your phone from the App
                        Store or Google Play. You can create a new account for
                        free or log in to your existing account.
                      </Box>
                    </li>
                    <li>
                      <LooksTwoIcon
                        sx={{ color: '#1da94a', mr: 1, mb: -0.7 }}
                      />
                      <Box>
                        <span style={{ fontWeight: 600 }}>
                          Enter Your Tax Details
                        </span>
                        <br />
                        Provide your basic personal information (Name, SSN,
                        Address) and total tax liability.
                      </Box>
                    </li>
                    <li>
                      <Looks3Icon sx={{ color: '#1da94a', mr: 1, mb: -0.7 }} />
                      <Box>
                        <span style={{ fontWeight: 600 }}>
                          Review & Transmit
                        </span>
                        <br />
                        Review and electronically transmit your extension to the
                        IRS. You&apos;ll receive an email notification from us
                        as soon as the IRS processes and updates the status of
                        your return.
                      </Box>
                    </li>
                  </Box>
                  <Box
                    sx={{
                      my: 1,
                      mb: 0,
                      '& img': {
                        width: { xs: 120, sm: 180 },
                        height: { xs: 37, sm: 55 },
                      },
                    }}
                  >
                    <Link
                      href="https://play.google.com/store/apps/details?id=com.taxzerone.extension4868"
                      target="_blank"
                      sx={{
                        mr: { xs: 1, sm: 1 },
                        my: { xs: 0, sm: 0 },
                        display: 'inline-block',
                      }}
                    >
                      <Tooltip title="Available on the Google Play" arrow>
                        <picture>
                          <source srcSet="/assets/images/play-store-img.webp" />
                          <source srcSet="/assets/images/play-store-img.png" />
                          <img
                            src="/assets/images/play-store-img.png"
                            alt="Available on the Google Play"
                            width={180}
                            height={55}
                          />
                        </picture>
                      </Tooltip>
                    </Link>
                    <Link
                      href="https://apps.apple.com/us/app/e-file-irs-extension-form-4868/id6478850013"
                      target="_blank"
                      sx={{
                        ml: { xs: 1, sm: 1 },
                        my: { xs: 0, sm: 0 },
                        display: 'inline-block',
                      }}
                    >
                      <Tooltip title="Download on the App Store" arrow>
                        <picture>
                          <source srcSet="/assets/images/app-store-img.webp" />
                          <source srcSet="/assets/images/app-store-img.png" />
                          <img
                            src="/assets/images/app-store-img.png"
                            alt="Download on the App Store"
                            width={180}
                            height={55}
                          />
                        </picture>
                      </Tooltip>
                    </Link>
                  </Box>
                </Box>
              </Stack>
            </Grid>
          </Grid>
        </Container>
      </Box>
      <Grid
        component="section"
        container
        sx={{
          backgroundColor: '#f0f2f9',

          mx: '0 !important',
          width: '100% !important',
          py: { xs: 1, sm: 3 },
        }}
        spacing={2}
        m={0}
      >
        <Container maxWidth="lg">
          <Grid
            container
            spacing={2}
            m={2}
            pb={4}
            className="MuiGrid-root-width"
            sx={{ justifyContent: 'center' }}
          >
            <Grid size={12}>
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mb: 3,
                  textAlign: 'center',
                  lineHeight: 1.5,
                }}
              >
                Who Should File Form 4868?
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
                  fontWeight: 400,
                  color: '#333333',
                  mb: 3,
                  textAlign: 'center',
                }}
              >
                IRS Extension{' '}
                <Link
                  href="/resources/tax-extension/form-4868-instructions/"
                  sx={{ color: '#0202ff' }}
                >
                  Form 4868
                </Link>{' '}
                for the 2025 tax year is filed by:
              </Typography>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 5.5 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 3,
                  textAlign: 'center',
                  borderWidth: 2,
                  borderColor: 'transparent',
                  borderRadius: 10,
                  height: '100%',
                  boxShadow: '10px 0px 30px rgba(91,98,117,.15)',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Individual Taxpayers
                </Typography>
                <Typography variant="body1">
                  Individual taxpayers—including U.S. citizens, residents, sole
                  proprietors, and single-member LLCs who need additional time.
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 5.5 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 3,
                  textAlign: 'center',
                  borderWidth: 2,
                  borderColor: 'transparent',
                  borderRadius: 10,
                  height: '100%',
                  boxShadow: '10px 0px 30px rgba(91,98,117,.15)',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  U.S. Citizens Living Abroad
                </Typography>
                <Typography variant="body1">
                  Taxpayers residing outside the U.S. and Puerto Rico or in
                  military or naval service on duty outside the U.S and Puerto
                  Rico who need additional time to organize documentation.
                </Typography>
              </Paper>
            </Grid>
          </Grid>
        </Container>
      </Grid>
      <Grid
        component="section"
        container
        sx={{
          // backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
        className="dotted-curve"
      >
        <Container maxWidth="lg" sx={{ mb: 5 }}>
          <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="center"
            spacing={2}
            m={2}
            mt={5}
            pb={0}
            className="MuiGrid-root-width"
          >
            <Grid size={12}>
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mb: 3,
                  textAlign: 'center',
                }}
              >
                Why TaxZerone is the Best App to E-File Form 4868?
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
                  fontWeight: 400,
                  color: '#333333',
                  mb: 3,
                  textAlign: 'center',
                }}
              >
                Powerful features that make individuals choose TaxZerone to file
                their income tax extension:
              </Typography>
            </Grid>
          </Grid>

          <Grid container spacing={2} m={2} mt={4} pb={{ xs: 0, sm: 4, md: 7 }}>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  px: 3,
                  pt: 5,
                  pb: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  borderColor: '#8492c0',
                  borderRadius: 10,
                  minHeight: '100%',
                  backgroundColor: '#fff',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#efefef',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/irs-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/irs-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/irs-icon.png"
                      alt="Instant IRS Acknowledgement"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Instant IRS Acknowledgement
                </Typography>
                <Typography variant="body1">
                  Instant IRS Acknowledgement Your extension is transmitted
                  directly to the IRS e-file system. Get acceptance confirmation
                  in minutes.
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  px: 3,
                  pt: 5,
                  pb: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  borderColor: '#76ce97',
                  borderRadius: 10,
                  minHeight: '100%',
                  backgroundColor: '#fff',
                  mt: { xs: 0, md: 4 },
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#efefef',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/guided-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/guided-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/guided-icon.png"
                      alt="Guided Filing"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Guided Filing
                </Typography>
                <Typography variant="body1">
                  Clear instructions for every field, you will know exactly what
                  information to enter and why it is needed, making the entire
                  filing process simple.
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  px: 3,
                  pt: 5,
                  pb: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  borderColor: '#8492c0',
                  borderRadius: 10,
                  minHeight: '100%',
                  backgroundColor: '#fff',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#efefef',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/instruction-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/instruction-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/instruction-icon.png"
                      alt="Smart Error Detection"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Smart Error Detection
                </Typography>
                <Typography variant="body1">
                  Our built-in error checking system will help you prevent
                  errors to avoid costly IRS rejections.
                </Typography>
              </Paper>
            </Grid>
            <Hidden mdDown>
              <Grid size={12}>&nbsp;</Grid>
            </Hidden>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  px: 3,
                  pt: 5,
                  pb: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  borderColor: '#76ce97',
                  borderRadius: 10,
                  minHeight: '100%',
                  backgroundColor: '#fff',

                  mt: { xs: 0, md: 4 },
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#efefef',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/time-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/time-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/time-icon.png"
                      alt="Real-Time Status"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Real-Time Status
                </Typography>
                <Typography variant="body1">
                  You can check on your return&apos;s filing status within the
                  app. If the return is rejected, you will receive specific
                  error code details so that you can correct and resubmit it
                  quickly.
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  px: 3,
                  pt: 5,
                  pb: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  borderColor: '#8492c0',
                  borderRadius: 10,
                  minHeight: '100%',
                  backgroundColor: '#fff',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#efefef',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/instant-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/instant-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/instant-icon.png"
                      alt="Deadline Reminders"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Deadline Reminders
                </Typography>
                <Typography variant="body1">
                  We will send you timely email reminders before your filing
                  deadline. You never have to worry about remembering important
                  tax dates. Stay ahead and file with confidence.
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  px: 3,
                  pt: 5,
                  pb: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  borderColor: '#76ce97',
                  borderRadius: 10,
                  minHeight: '100%',
                  backgroundColor: '#fff',

                  mt: { xs: 0, md: 4 },
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#efefef',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/support-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/support-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/support-icon.png"
                      alt="Friendly Support"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Friendly Support
                </Typography>
                <Typography variant="body1">
                  Need help? Our friendly expert is here to assist you via Live
                  Chat & Email (24/7), and Phone (Monday to Friday, between 9 AM
                  and 5 PM CST).
                </Typography>
              </Paper>
            </Grid>
          </Grid>
        </Container>
      </Grid>
      <Grid
        component="section"
        container
        sx={{
          backgroundColor: '#1da94a',
          py: { lg: 8, md: 8, sm: 4, xs: 4 },
          mx: '0 !important',
          width: '100% !important',
          mb: 0,
          p: 2,
          textAlign: 'center',
        }}
        m={2}
        mt={0}
        className="curve-bg"
        spacing={2}
      >
        <Container maxWidth="lg">
          <Grid container spacing={2} className="MuiGrid-root-width">
            <Grid size={12} textAlign="center">
              <Typography
                variant="h2"
                color="white"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mb: 3,
                  textAlign: 'center',
                  lineHeight: 1.5,
                }}
              >
                E-File IRS Extension 4868 at the Most
                <br />
                Affordable Price in the Industry
              </Typography>
            </Grid>
            <Grid size={{ xs: 12, sm: 12, md: 12 }} textAlign="center">
              <Container
                maxWidth="md"
                sx={{
                  mb: 5,
                  backgroundColor: '#fff',
                  borderRadius: 10,
                  p: 2,
                  boxShadow: '10px 0px 30px rgba(91,98,117,.15)',
                }}
              >
                <Stack
                  direction={{ xs: 'column', sm: 'row' }}
                  justifyContent="center"
                  alignItems="center"
                  spacing={{ xs: 0, sm: 3 }}
                >
                  <Box>
                    <Typography variant="body1">
                      Extension to File <br />
                      Individual Income Tax Return
                    </Typography>
                    <Typography
                      variant="h3"
                      sx={{
                        fontSize: { xs: 28, sm: 34, md: 40 },
                        fontWeight: 700,
                        mt: 2,
                        color: '#213e99',
                        mb: 0,
                        minWidth: 300,
                      }}
                    >
                      $11.99
                      <Box
                        component="span"
                        sx={{
                          fontSize: { xs: 18, sm: 24, md: 30 },
                          fontWeight: 300,
                          color: '#444',
                        }}
                      >
                        /return
                      </Box>
                    </Typography>
                  </Box>
                  <List sx={{ p: 0, m: 0, width: '100%' }}>
                    <ListItem sx={{ px: 0 }}>
                      <ListItemIcon sx={{ minWidth: 30 }}>
                        <CheckCircleRoundedIcon color="secondary" />
                      </ListItemIcon>
                      <ListItemText>
                        <Typography
                          sx={{ fontWeight: 500, fontSize: 16 }}
                          color="secondary"
                        >
                          IRS-authorized secure e-filing
                        </Typography>
                      </ListItemText>
                    </ListItem>
                    <ListItem sx={{ px: 0 }}>
                      <ListItemIcon sx={{ minWidth: 30 }}>
                        <CheckCircleRoundedIcon color="secondary" />
                      </ListItemIcon>
                      <ListItemText>
                        <Typography
                          sx={{ fontWeight: 500, fontSize: 16 }}
                          color="secondary"
                        >
                          File your extension in minutes
                        </Typography>
                      </ListItemText>
                    </ListItem>
                    <ListItem sx={{ px: 0 }}>
                      <ListItemIcon sx={{ minWidth: 30 }}>
                        <CheckCircleRoundedIcon color="secondary" />
                      </ListItemIcon>
                      <ListItemText>
                        <Typography
                          sx={{ fontWeight: 500, fontSize: 16 }}
                          color="secondary"
                        >
                          Instant IRS acceptance confirmation
                        </Typography>
                      </ListItemText>
                    </ListItem>
                  </List>
                </Stack>
              </Container>
              <Box component="div" sx={{ margin: 'auto' }}>
                <Button
                  variant="contained"
                  sx={{
                    mb: { xs: 0, md: 0 },
                    transition: 'all 0.3s ease 0s',
                    display: { xs: 'inline-flex', sm: 'inline-flex' },
                    '&:hover, &active': {
                      transform: 'scale(1.1)',
                    },
                  }}
                  className="btn-primary"
                  href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=mobile868`}
                >
                  File Form 4868 Now
                </Button>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Grid>
      <Grid
        component="section"
        container
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
          py: 0,
        }}
        spacing={0}
        m={0}
      >
        <Container maxWidth="lg">
          <Grid
            container
            spacing={2}
            m={0}
            mt={0}
            className="MuiGrid-root-width"
            flexDirection={{ xs: 'column-reverse', md: 'row' }}
          >
            <Grid
              size={{ xs: 12, md: 6 }}
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                textAlign: {
                  lg: 'left',
                  md: 'left',
                  sm: 'center',
                  xs: 'center',
                },
              }}
            >
              <Box sx={{ mb: { xs: 3, md: 3 }, mt: { xs: -3, md: 3 } }}>
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                    fontWeight: 600,
                    mb: 3,
                  }}
                >
                  Download Our IRS Form 4868 Mobile App — File Your Tax
                  Extension Anywhere
                </Typography>
                <Typography
                  variant="body1"
                  sx={{
                    fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
                    fontWeight: 400,
                    color: '#333333',
                    mb: 2,
                  }}
                >
                  Request your personal tax extension in minutes — fast, secure,
                  and fully online.
                </Typography>
                <Typography
                  variant="body1"
                  sx={{
                    fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
                    fontWeight: 400,
                    color: '#333333',
                    mb: 2,
                  }}
                >
                  Available on iPhone, iPad, and Android devices.
                </Typography>

                <Box
                  sx={{
                    mt: 2,
                    mb: 1,
                    '& img': {
                      width: { xs: 120, sm: 180 },
                      height: { xs: 37, sm: 55 },
                    },
                  }}
                >
                  <Link
                    href="https://play.google.com/store/apps/details?id=com.taxzerone.extension4868"
                    target="_blank"
                    sx={{
                      mr: { xs: 1, sm: 1 },
                      my: { xs: 0, sm: 0 },
                      display: 'inline-block',
                    }}
                  >
                    <Tooltip title="Available on the Google Play" arrow>
                      <picture>
                        <source
                          srcSet="/assets/images/play-store-img.webp"
                          width={180}
                          height={55}
                        />
                        <source
                          srcSet="/assets/images/play-store-img.png"
                          width={180}
                          height={55}
                        />
                        <img
                          src="/assets/images/play-store-img.png"
                          alt="Available on the Google Play"
                          width={180}
                          height={55}
                        />
                      </picture>
                    </Tooltip>
                  </Link>
                  <Link
                    href="https://apps.apple.com/us/app/e-file-irs-extension-form-4868/id6478850013"
                    target="_blank"
                    sx={{
                      ml: { xs: 1, sm: 1 },
                      my: { xs: 0, sm: 0 },
                      display: 'inline-block',
                    }}
                  >
                    <Tooltip title="Download on the App Store" arrow>
                      <picture>
                        <source
                          srcSet="/assets/images/app-store-img.webp"
                          width={180}
                          height={55}
                        />
                        <source
                          srcSet="/assets/images/app-store-img.png"
                          width={180}
                          height={55}
                        />
                        <img
                          src="/assets/images/app-store-img.png"
                          alt="Download on the App Store"
                          width={180}
                          height={55}
                        />
                      </picture>
                    </Tooltip>
                  </Link>
                </Box>
              </Box>
            </Grid>
            <Grid size={{ md: 6, xs: 12 }} textAlign="right">
              <Box
                component="div"
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  height: '100%',
                }}
              >
                <picture>
                  <source
                    srcSet="/assets/images/4868-mobile-app-img.webp"
                    className="img-responsive"
                  />
                  <source
                    srcSet="/assets/images/4868-mobile-app-img.png"
                    className="img-responsive"
                  />
                  <img
                    src="/assets/images/4868-mobile-app-img.png"
                    alt="Download Our IRS Form 4868 Mobile App — File Your Tax Extension Anywhere "
                    className="img-responsive"
                    loading="lazy"
                    width={657}
                    height={770}
                  />
                </picture>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Grid>

      <Container component="section" maxWidth="lg">
        <Grid
          container
          spacing={2}
          m={2}
          direction="row"
          justifyContent="center"
          className="MuiGrid-root-width"
          sx={{ my: { xs: 0, sm: 2 } }}
        >
          <Grid
            size={{ xs: 12, sm: 10, md: 9 }}
            textAlign="left"
            my={{ xs: 2, sm: 5 }}
            mb={3}
          >
            <Typography
              variant="h2"
              sx={{
                fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                fontWeight: 600,
                mb: 5,
                textAlign: 'center',
              }}
            >
              Frequently Asked Questions
            </Typography>
            <Box
              component="div"
              sx={{ mb: 5 }}
              itemScope
              itemType="https://schema.org/FAQPage"
            >
              <Box
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  1. Can I file Form 4868 completely from my phone?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Box component="div" itemProp="text">
                    <Typography variant="body1" sx={{ mt: 1 }}>
                      Yes, you can{' '}
                      <Link
                        href="/tax-extension/efile-irs-form-4868-personal-tax-extension-online/"
                        sx={{ color: '#0202ff' }}
                      >
                        file Form 4868
                      </Link>{' '}
                      completely from your phone. Enter your personal details,
                      estimate taxes owed, review, and transmit them directly to
                      the IRS.
                    </Typography>
                  </Box>
                </Box>
              </Box>
              <Box
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  2. Can I save my Form 4868 and complete it later?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Typography variant="body1" sx={{ mt: 1 }} itemProp="text">
                    You can save your Form 4868 and finish it later. Your data
                    is automatically saved to your account as you work through
                    the filing process. At any point, you can log out and come
                    back when it&apos;s convenient to complete and submit your
                    extension request before the deadline.
                  </Typography>
                </Box>
              </Box>
              <Box
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  3. Does Form 4868 give me more time to pay taxes?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Typography variant="body1" sx={{ mt: 1 }} itemProp="text">
                    No, the form 4868 extends only your time to file a return
                    with the IRS — not your time to pay taxes owed. Any balance
                    due must be paid by the original filing due dates.
                  </Typography>
                </Box>
              </Box>
            </Box>
            <Box sx={{ textAlign: 'center', mt: 3 }}>
              <Button
                variant="outlined"
                color="secondary"
                size="large"
                sx={{
                  borderWidth: 2,
                  borderRadius: 3,
                  textTransform: 'none',
                  '&:hover, &:focus, &:active': { borderWidth: 2 },
                }}
                href="/faqs/form-4868/"
              >
                More FAQs
              </Button>
            </Box>
          </Grid>
        </Grid>
      </Container>
    </AppLayout>
  );
};

export default MobileAppForm4868;
